import type { CacheProfile, CacheProfileConfig } from './types';

/**
 * Named cache profiles control per-observer stale time and refetch behavior.
 * The same cache entry can be observed with different profiles —
 * the profile affects when THIS observer considers data stale, not the cache itself.
 */
export const cacheProfiles: Record<CacheProfile, CacheProfileConfig> = {
    /** Standard profile: 2-min stale time, no refetch on mount/focus */
    default: {
        staleTime: 2 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: 'always',
    },
    /** Editor profile: 5-min stale time, refetch stale data on mount */
    editor: {
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: 'always',
    },
};
